import { render, staticRenderFns } from "./Surgery.vue?vue&type=template&id=ec674014&scoped=true"
import script from "./Surgery.vue?vue&type=script&lang=js"
export * from "./Surgery.vue?vue&type=script&lang=js"
import style0 from "./Surgery.vue?vue&type=style&index=0&id=ec674014&prod&scoped=true&lang=css"
import style1 from "./Surgery.vue?vue&type=style&index=1&id=ec674014&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec674014",
  null
  
)

export default component.exports